/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useCatalogEntryList } from '@/data/Content/CatalogEntryList';
import { ContentContext } from '@/data/context/content';
import { useLocalization } from '@/data/Localization';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { FC, useContext } from 'react';
import { plpSelectSX } from '../styles/container';

export const CatalogEntryListSort: FC = () => {
	const { sortOptions, selectedSortOption, onSortOptionChange } = useContext(
		ContentContext
	) as ReturnType<typeof useCatalogEntryList>;
	const listSettingsNLS = useLocalization('CommerceEnvironment').listSettings;
	const ProductGrid = useLocalization('ProductGrid').Labels;

	return (
		<FormControl sx={{marginTop:'0 !important', flexDirection:'row', alignItems:'center', columnGap:0.5}}>
			<InputLabel id="productGrid_sort_label">{`${ProductGrid.sortBy.t()}:`}</InputLabel>
			<Select
				labelId='productGrid_sort_label'
				data-testid="list-sort-option"
				id="productGrid_select"
				value={selectedSortOption}
				onChange={onSortOptionChange}
				fullWidth
				sx={plpSelectSX}
				size='small'
			>
				{sortOptions?.map((option) => (
					<MenuItem
						value={option.value}
						key={option.value}
						id={`productGrid_option_${option.value}`}
						data-testid={`productGrid_option_${option.value}`}
					>
						{listSettingsNLS[option.translationKey].t()}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}; 